import ProxyCenter from './ProxyCenter'
export default [
    {
        name: 'ProxyCenter',
        path: 'ProxyCenter',
        redirect: { name: 'zlAllCase' }, // 重定向到指定名称的路由,
        component: () => import('@/pages/BigData/ProxyCenter'),
        // 添加元信息，用于标记该路由需要认证
        meta: { title: '代报中心', requiresAuth: true },
        props(route) {
            return { id: route.query.id }
        },
        children: [...ProxyCenter]
    },
    {
        name: 'PatentSearch',
        path: 'PatentSearch',
        component: () => import('@/pages/BigData/PatentSearch'),
        meta: { title: '专利搜索' },
        props(route) {
            return { id: route.query.id }
        },
    },
    {
        name: 'WaitSync',
        path: 'WaitSync',
        component: () => import('@/pages/BigData/WaitSync'),
        meta: { title: '待更新' },
        props(route) {
            return { id: route.query.id }
        },
    },
    {
        name: 'PatentAll',
        path: 'PatentAll',
        component: () => import('@/pages/BigData/PatentAll'),
        meta: { title: '全部' },
        props(route) {
            return { id: route.query.id }
        },
        children: [
            {
                name: 'PatentDetailsAll',
                path: 'PatentDetailsAll',
                component: () => import('@/pages/BigData/PatentDetails'),
                meta: { title: '详情' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            }
        ]
    },
    {
        name: 'Normal',
        path: 'Normal',
        component: () => import('@/pages/BigData/Normal'),
        meta: { title: '正常' },
        props(route) {
            return { id: route.query.id }
        },
        children: [
            {
                name: 'PatentDetails',
                path: 'PatentDetails',
                component: () => import('@/pages/BigData/PatentDetails'),
                meta: { title: '详情' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            }
        ]
    },
    {
        name: 'Expire',
        path: 'Expire',
        component: () => import('@/pages/BigData/Expire'),
        meta: { title: '已过期' },
        props(route) {
            return { id: route.query.id }
        },
        children: [
            {
                name: 'PatentDetailsExpire',
                path: 'PatentDetailsExpire',
                component: () => import('@/pages/BigData/PatentDetails'),
                meta: { title: '详情' },
                props(route) {
                    return {
                        id: route.query.id, 
                    }
                },
            }
        ]
    },
    {
        name: 'Lose',
        path: 'Lose',
        component: () => import('@/pages/BigData/Lose'),
        meta: { title: '已失效' },
        props(route) {
            return { id: route.query.id }
        },
        children: [
            {
                name: 'PatentDetailsLose',
                path: 'PatentDetailsLose',
                component: () => import('@/pages/BigData/PatentDetails'),
                meta: { title: '详情' },
                props(route) {
                    return {
                        id: route.query.id,

                    }
                },
            }
        ]
    },
    {
        name: 'Recycle',
        path: 'Recycle',
        component: () => import('@/pages/BigData/Recycle'),
        meta: { title: '回收站' },
        props(route) {
            return { id: route.query.id }
        },
        children: [
            {
                name: 'PatentDetailsRecycle',
                path: 'PatentDetailsRecycle',
                component: () => import('@/pages/BigData/PatentDetails'),
                meta: { title: '详情' },
                props(route) {
                    return {
                        id: route.query.id,

                    }
                },
            }
        ]
    },
    {
        name: 'YearlyFeeDelegate',
        path: 'YearlyFeeDelegate',
        redirect: { name: 'CommissionDetails' },
        component: () => import('@/pages/BigData/YearlyFeeDelegate'),
        meta: { title: '年费代缴' },
        props(route) {
            return { id: route.query.id }
        },
        children: [
            {
                name: 'CommissionDetails',
                path: 'CommissionDetails',
                redirect: { name: 'AllEntrustmentDetails' },
                component: () => import('@/pages/BigData/YearlyFeeDelegate/CommissionDetails'),
                meta: { title: '委托明细' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
                children: [
                    {
                        name: 'AllEntrustmentDetails',
                        path: 'AllEntrustmentDetails',
                        component: () => import('@/pages/BigData/YearlyFeeDelegate/CommissionDetails/AllEntrustmentDetails'),
                        meta: { title: '全部' },
                        props(route) {
                            return {
                                id: route.query.id,
                            }
                        },
                    },
                    {
                        name: 'InSettlement',
                        path: 'InSettlement',
                        component: () => import('@/pages/BigData/YearlyFeeDelegate/CommissionDetails/InSettlement'),
                        meta: { title: '结算中' },
                        props(route) {
                            return {
                                id: route.query.id,
                            }
                        },
                    },
                    {
                        name: 'ToBeCharged',
                        path: 'ToBeCharged',
                        component: () => import('@/pages/BigData/YearlyFeeDelegate/CommissionDetails/ToBeCharged'),
                        meta: { title: '代缴费' },
                        props(route) {
                            return {
                                id: route.query.id,
                            }
                        },
                    },
                    {
                        name: 'InPaymentProcess',
                        path: 'InPaymentProcess',
                        component: () => import('@/pages/BigData/YearlyFeeDelegate/CommissionDetails/InPaymentProcess'),
                        meta: { title: '正在缴费' },
                        props(route) {
                            return {
                                id: route.query.id,
                            }
                        },
                    },
                    {
                        name: 'FeePaid',
                        path: 'FeePaid',
                        component: () => import('@/pages/BigData/YearlyFeeDelegate/CommissionDetails/FeePaid'),
                        meta: { title: '已缴费' },
                        props(route) {
                            return {
                                id: route.query.id,
                            }
                        },
                    },

                ]
            },
            {
                name: 'AnnualFeeBill',
                path: 'AnnualFeeBill',
                redirect: { name: 'BillsToBePaid' },
                component: () => import('@/pages/BigData/YearlyFeeDelegate/AnnualFeeBill'),
                meta: { title: '年费账单' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
                children: [
                    {
                        name: 'BillsToBePaid',
                        path: 'BillsToBePaid',
                        component: () => import('@/pages/BigData/YearlyFeeDelegate/AnnualFeeBill/BillsToBePaid'),
                        meta: { title: '待支付' },
                        props(route) {
                            return {
                                id: route.query.id,
                            }
                        },
                    },
                    {
                        name: 'PaidBills',
                        path: 'PaidBills',
                        component: () => import('@/pages/BigData/YearlyFeeDelegate/AnnualFeeBill/PaidBills'),
                        meta: { title: '待支付' },
                        props(route) {
                            return {
                                id: route.query.id,
                            }
                        },
                    },
                ]
            },
        ]
    },
    {
        name: 'AutoUpdate',
        path: 'AutoUpdate',
        component: () => import('@/pages/BigData/AutoUpdate'),
        meta: { title: '自动更新' },
        props(route) {
            return { id: route.query.id }
        },
        children: [
            {
                name: 'PatentDetailsAutoUpdate',
                path: 'PatentDetailsAutoUpdate',
                component: () => import('@/pages/BigData/PatentDetails'),
                meta: { title: '详情' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            }
        ]
    },
    {
        name: 'My',
        path: 'My',
        component: () => import('@/pages/BigData/My'),
        meta: { title: '个人中心' },
        props(route) {
            return {
                id: route.query.id,
            }
        },
        children: [
            {
                name: 'QueryRecord',
                path: 'QueryRecord',
                component: () => import('@/pages/BigData/QueryRecord'),
                meta: { title: '检索记录' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'RechargeRecord',
                path: 'RechargeRecord',
                component: () => import('@/pages/BigData/RechargeRecord'),
                meta: { title: '充值记录' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'TransactionRecord',
                path: 'TransactionRecord',
                component: () => import('@/pages/BigData/TransactionRecord'),
                meta: { title: '交易记录' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'Recharge',
                path: 'Recharge',
                component: () => import('@/pages/BigData/Recharge'),
                meta: { title: '充值中心' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
        ]
    },
]